import { REQUEST_FETCH_TRUMPISMS, REQUEST_GET_TRUMPISM } from './types';

export function requestTrumpism(id) {
  return {
    type: REQUEST_GET_TRUMPISM,
    id
  };
}

export function requestTrumpisms(date) {
  return {
    type: REQUEST_FETCH_TRUMPISMS,
    date
  };
}



// WEBPACK FOOTER //
// ./src/actions/trumpisms.js